import styled from '@emotion/styled';
import { Container as RootContainer } from '@presentation/components';
import { responsiveFontSize } from '@presentation/styles';
import hero from '../assets/hero.webp';

export const Container = styled.div`
  height: 500px;
  background: url(${hero}) no-repeat top center;
  background-size: cover;
  background-position-y: bottom;
`;

export const Content = styled(RootContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  max-width: 600px;
  color: ${(props) => props.theme.color.light.default};
  text-align: center;
`;

export const Title = styled.h1`
  ${responsiveFontSize(52, 4)};
  font-family: ${(props) => props.theme.font.alternate};
`;

export const Subtitle = styled.div`
  margin-top: 24px;
`;

export const Button = styled.div`
  margin-top: 24px;
`;
